// extracted by mini-css-extract-plugin
export default {"modalContainer":"customModal_modalContainer__GMJF6","modalHeader":"customModal_modalHeader__D3A1J","modalBody":"customModal_modalBody__NkAt5"};